import React, { useState } from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Checkbox } from './ui/checkbox';
import { useToast } from '../hooks/use-toast';
import { Send } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const ContactSection = () => {
  const { toast } = useToast();
  const { t } = useLang();
  const [form, setForm] = useState({ nome: '', cognome: '', email: '', messaggio: '' });
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.messaggio) {
      toast({ title: t('contact.errMissingTitle'), description: t('contact.errMissing'), variant: 'destructive' });
      return;
    }
    if (!accepted) {
      toast({ title: t('contact.errPrivacyTitle'), description: t('contact.errPrivacy'), variant: 'destructive' });
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      toast({ title: t('contact.okTitle'), description: t('contact.okBody') });
      setForm({ nome: '', cognome: '', email: '', messaggio: '' });
      setAccepted(false);
    }, 900);
  };

  const fieldClass =
    'h-12 border-0 border-b border-[#cbd5e1] rounded-none focus-visible:ring-0 focus-visible:border-[#c53114] bg-transparent px-0';

  return (
    <section id="contatti" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <p className="text-xs tracking-[0.3em] text-[#c53114] font-semibold uppercase">{t('contact.eyebrow')}</p>
        <h2
          className="mt-2 text-3xl md:text-5xl font-semibold text-[#0b2545]"
          style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif", letterSpacing: '0.02em' }}
        >
          {t('contact.title')}
        </h2>
        <p className="mt-4 text-[#475569] max-w-2xl leading-relaxed">{t('contact.body')}</p>

        <form onSubmit={onSubmit} className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#0b2545] mb-2">{t('contact.fields.name')}</label>
            <Input name="nome" value={form.nome} onChange={onChange} className={fieldClass} />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#0b2545] mb-2">{t('contact.fields.surname')}</label>
            <Input name="cognome" value={form.cognome} onChange={onChange} className={fieldClass} />
          </div>
          <div className="md:col-span-2">
            <label className="block text-xs uppercase tracking-widest text-[#0b2545] mb-2">{t('contact.fields.email')}</label>
            <Input type="email" name="email" value={form.email} onChange={onChange} className={fieldClass} />
          </div>
          <div className="md:col-span-2">
            <label className="block text-xs uppercase tracking-widest text-[#0b2545] mb-2">{t('contact.fields.message')}</label>
            <Textarea name="messaggio" value={form.messaggio} onChange={onChange} rows={5} className={`${fieldClass} h-auto resize-none`} />
          </div>
          <div className="md:col-span-2 flex items-start gap-3">
            <Checkbox id="privacy" checked={accepted} onCheckedChange={(v) => setAccepted(!!v)} className="mt-1" />
            <label htmlFor="privacy" className="text-sm text-[#475569] leading-relaxed">
              {t('contact.privacy')} <a href="/privacy-policy" className="text-[#c53114] underline">{t('contact.privacyLink')}</a>
            </label>
          </div>
          <div className="md:col-span-2">
            <button
              type="submit"
              disabled={submitting}
              className="inline-flex items-center gap-2 bg-[#0b2545] text-white px-8 py-3 tracking-[0.2em] text-sm uppercase font-semibold hover:bg-[#c53114] transition-colors disabled:opacity-60"
            >
              {submitting ? t('contact.submitting') : t('contact.submit')} <Send size={16} />
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
